import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {EvkOption, MessageCrudService} from "@evomatik/evk-common";
import {TareaDocumentoConsultasService} from "../../services/tarea-documento-consultas.service";
import {ExpedienteCreateService} from "../../../expediente/services/expediente-create.service";
import {EvkDefaultValuesStorageService} from "@evomatik/evk-forms";
import {TipoExpedienteEnum} from "../../../expediente/enums/tipo-expediente-enum";
import {BehaviorSubject, combineLatest, forkJoin, Observable, of, Subject} from "rxjs";
import {EvkDiligenciaConfigModel} from "../../models/diligencia-config.model";
import {AbstractControl, FormControl, FormGroup, Validators} from "@angular/forms";
import {filter, map, startWith, take} from "rxjs/operators";
import {EvkExpedienteModel} from "../../../expediente/models/evk-expediente.model";
import {EvkExpedienteConfigModel} from "../../../expediente/models/evk-expediente-config.model";

@Component({
    selector: 'lib-diligencia-respues',
    templateUrl: './evk-diligencia-respuesta.component.html',
    styleUrls: ['./evk-diligencia-respuesta.component.scss']
})
export class EvkDiligenciaRespuestaComponent implements OnInit{

    catalogosCargados: EventEmitter<boolean> = new EventEmitter();

    @Input()
    idDiligenciaConfig: string;
    @Input()
    idDiligenciaSolicitud: string;
    @Output()
    responderDiligencia: EventEmitter<any> = new EventEmitter<any>();
    @Output()
    regresar: EventEmitter<any> = new EventEmitter<any>();
    form: FormGroup = new FormGroup({});
    diligenciaOptions = [];
    diligenciaFilteredOptions$: Observable<any[]>;
    expediente: EvkExpedienteModel = new EvkExpedienteModel();
    configExpediente: EvkExpedienteConfigModel = new EvkExpedienteConfigModel();
    constructor(
        public messageCrudService: MessageCrudService,
        public tareaDocumentoConsultasService: TareaDocumentoConsultasService,
        public expedienteCreateService: ExpedienteCreateService,
        private valuesStorageService: EvkDefaultValuesStorageService,
    ) {
    }

    ngOnInit(): void {
        this.cargaCatalogos();
        this.eventHandlerEventInit();
        this.buildForm(this.form);
    }

    cargaCatalogos() {
        const requests = [];
        requests.push(this.tareaDocumentoConsultasService.getDiligenciasRespuestas(this.idDiligenciaConfig));
        forkJoin(requests).subscribe((
            [res1]:
                [EvkOption[], EvkDiligenciaConfigModel[]]
        ) => {
            res1.forEach(element => {
                this.diligenciaOptions.push(this.buildOption(element, 'nombre'));
            });
            this.catalogosCargados.emit(true);
        });
    }
    buildOption(data: any, labelProp: string): any {
        const label = data[labelProp];
        return {
            label: label,
            value: data['id'],
            active: data['activo'],
            configuracionExpediente: data['configuracionExpediente'],
            id: data['id']
        };
    }

    eventHandlerEventInit() {
        this.catalogosCargados.subscribe((res) => {
            if (res) {
                this.diligenciaFilteredOptions$ = this.filterOptions(this.form.controls.diligenciaRespuesta, of(this.diligenciaOptions));
            }
        });
    }
    buildForm(form?: FormGroup) {
        form.addControl('diligenciaRespuesta', new FormControl(null, Validators.required));
    }
    filterOptions = (formControl: FormControl | AbstractControl, opciones$: Observable<EvkOption[]>, valueChanges?: Observable<any> | Subject<any> | BehaviorSubject<any>) => {
        const valueChanges$ = valueChanges ? valueChanges : formControl.valueChanges;
        return combineLatest(
            [
                valueChanges$.pipe(startWith('')),
                opciones$
            ]
        ).pipe(
            filter(([value, _]) => typeof value === 'string'
            ),
            map(([name, opciones]) => name ? this._filter(name, opciones) : opciones.slice())
        );

    }
    _filter(label: string, options: EvkOption[]): EvkOption[] {
        const filterValue = this.removeAccents(label.toLowerCase());
        return options.filter(
            option =>
                this.removeAccents(option.label.toLowerCase()).indexOf(filterValue) !== -1);
    }
    removeAccents = (str) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    continuar() {
        this.expediente.configuracionExpediente = this.configExpediente;
        this.expediente.idDiligenciaPadre = this.idDiligenciaSolicitud;
        this.expediente.idDiligenciaConfig = this.idDiligenciaConfig;
        this.expediente.enviadaComoRespuesta = false;
        this.expedienteCreateService.save(this.expediente).pipe(take(1)).subscribe(
            (response) => {
                this.expediente = response.data;
                this.expediente.idDiligenciaConfig = this.idDiligenciaConfig;
                this.responderDiligencia.emit(this.expediente);
            }, () => {
                this.messageCrudService.snackbarMessage('No se ha podido guardar');
            }
        );
    }
    onSelectDiligencia(event) {
        console.log('Diligencia: ', event)
        if (event) {
            this.idDiligenciaConfig = event.id;
            this.configExpediente.nombre = event.configuracionExpediente.label;
            this.configExpediente.id = event.configuracionExpediente.value;
        }
    }
    goBack() {
        this.regresar.emit();
    }
    displayFn = (option) => (option && option.label) ? option.label : '';
}
